import { create } from 'zustand';

export interface UserStoreState {
  cards: any[];
  loading: boolean;
}

interface UserPhoneStoreActions {
  setUserCards: (user: UserStoreState) => void;
  setLoading: (state: boolean) => void;
}

interface UserStore {
  state: UserStoreState;
  actions: UserPhoneStoreActions;
}

export const useUserCardsStore = create<UserStore>((set) => ({
  state: {
    cards: [],
    loading: false,
  },
  actions: {
    setUserCards: (cards) => set({ state: cards }),
    setLoading: (load) =>
      set((state) => {
        return { state: { ...state.state, load } };
      }),
  },
}));
